import React from 'react';
import { Shield, Cpu, Clock, Users } from 'lucide-react';
import { differentialsData } from '../mock/data';

const iconMap = {
  Shield,
  Cpu,
  Clock,
  Users
};

const Differentials = () => {
  return (
    <section id="diferenciais" className="py-20 !bg-[rgba(221,193,131,0.2)]">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#033530] mb-4">
            Nossos Diferenciais
          </h2>
          <p className="text-lg text-[#033530]/70">Saiba por que escolher nossos serviços

          </p>
        </div>

        {/* Differentials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {differentialsData.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="bg-white rounded-2xl p-8 text-center hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-[#ddc183]/20 group">

                {/* Icon */}
                <div className="w-20 h-20 bg-[#033530] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-[#ddc183] transition-colors duration-300">
                  <IconComponent className="text-[#ddc183] group-hover:text-[#033530]" size={36} />
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-[#033530] mb-4">
                  {item.title}
                </h3>

                {/* Description */}
                <p className="text-[#033530]/70 leading-relaxed">
                  {item.description}
                </p>
              </div>);

          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-[#033530] text-lg mb-6">
            Experiência comprovada e comprometimento com a excelência técnica
          </p>
          <div className="flex items-center justify-center gap-2">
            <div className="w-16 h-1 bg-[#ddc183]" />
            <span className="text-[#033530]/50 text-sm font-medium">CREA Certificado</span>
            <div className="w-16 h-1 bg-[#ddc183]" />
          </div>
        </div>
      </div>
    </section>);

};

export default Differentials;